import { defineComponent as ce, useSlots as ue, useTemplateRef as P, ref as w, useId as de, computed as r, onMounted as ve, nextTick as me, onBeforeUnmount as fe, watch as q, openBlock as o, createElementBlock as N, normalizeClass as h, createElementVNode as E, createBlock as k, resolveDynamicComponent as B, withCtx as pe, createTextVNode as he, toDisplayString as H, createCommentVNode as c, toRaw as U, createVNode as be } from "vue";
import { useSwipe as xe, useResizeObserver as Ce, useMutationObserver as ge } from "@vueuse/core";
import "@ds/components/Button";
import { deprecatePropNames as ye } from "../../composables/usePropsDeprecation.js";
import { isIntersectionObserverAvailable as we } from "../../utils/intersectionObserver.js";
import { tw as L } from "../../utils/tailwind.js";
import { skipFragment as ke, isVNodeEmpty as Se } from "../../utils/vnode.js";
import { desktopCardWidths as j, mobileCardWidths as Y, cardWidths as Te, SCROLL_ANNOUNCEMENT_DELAY as We } from "./CardCarousel.constant.js";
import G from "./components/CardCarouselController.vue2.js";
import Ae from "./components/CardCarouselItems.vue2.js";
const Ne = {
  key: 0,
  "aria-roledescription": "carousel",
  class: "relative flex flex-col",
  "data-test": "card-carousel"
}, Ie = { class: "flex grow flex-col" }, ze = ["aria-label"], Ee = {
  key: 1,
  class: "isolate mt-8 flex"
}, qe = /* @__PURE__ */ ce({
  name: "CardCarousel",
  __name: "CardCarousel",
  props: {
    headingSize: { default: "medium" },
    center: { type: Boolean, default: !0 },
    desktopCardWidth: { default: "standard" },
    mobileCardWidth: { default: "standard" },
    prevAlternativeText: {},
    nextAlternativeText: {},
    size: { default: "small" },
    title: { default: "" },
    titleTag: { default: "h2" },
    ariaLabelledby: { default: void 0 },
    subtitle: { default: "" }
  },
  emits: ["slide-impression"],
  setup(s, { emit: J }) {
    const l = s, I = ue(), V = J, i = P("carousel-scroller"), R = P(
      "carousel-items"
    ), u = w(!1), d = w(!1), { direction: K } = xe(i, { threshold: 50 }), O = de(), z = `${O}_title`, $ = `${O}_subtitle`, f = r(() => u.value || d.value), Q = r(() => [
      u.value && d.value && L`gradient-mask-lr-80`,
      u.value && !d.value && L`gradient-mask-l-90`,
      !u.value && d.value && L`gradient-mask-r-90`
    ]), D = w(""), b = r(
      () => ke(I?.default({})).filter(
        (t) => !Se(t)
      )
    ), x = w(void 0), C = w(void 0);
    let n = null;
    const M = () => {
      const t = i.value, e = R.value?.$el;
      if (!t || !e || !we()) {
        x.value = void 0, C.value = void 0;
        return;
      }
      n && (n.disconnect(), n = null);
      const a = /* @__PURE__ */ new Set();
      n = new IntersectionObserver(
        (W) => {
          if (W.forEach((m) => {
            const A = Array.from(e.children).indexOf(
              m.target
            );
            if (A === -1) return;
            const p = A + 1;
            m.isIntersecting && m.intersectionRatio >= 1 ? a.add(p) : a.delete(p);
          }), a.size > 0) {
            const m = Array.from(a);
            x.value = Math.min(...m), C.value = Math.max(...m);
          } else
            x.value = void 0, C.value = void 0;
        },
        {
          root: t,
          rootMargin: "0px",
          // Use threshold array to get callbacks at 0% and 100% visibility
          // This allows us to detect when items become fully visible or leave
          threshold: [0, 1]
        }
      ), Array.from(e.children).forEach((W) => {
        n?.observe(W);
      });
    }, F = (t) => {
      V("slide-impression", { direction: t }), requestAnimationFrame(() => {
        const e = i.value;
        if (!e) return;
        const a = e.clientWidth, T = t === "forward" ? e.scrollLeft + a : e.scrollLeft - a;
        e.scrollTo({
          left: T,
          behavior: "smooth"
        });
      });
    }, X = (t, e) => {
      const a = t.getBoundingClientRect();
      return a.left >= e.left && a.right <= e.right && a.top >= e.top && a.bottom <= e.bottom;
    }, Z = (t) => {
      F(t), setTimeout(() => {
        const e = i.value, a = R.value?.$el;
        if (!e || !a) return;
        const T = e.getBoundingClientRect(), A = Array.from(a.children).filter(
          (p) => X(p, T)
        ).map((p) => p.textContent?.trim()).filter(Boolean).join(", ");
        D.value = A;
      }, We);
    }, _ = async () => {
      const t = i?.value?.scrollWidth ?? 0, e = (i?.value?.clientWidth ?? 0) + (i?.value?.scrollLeft ?? 0);
      d.value = e < t;
    }, ee = () => {
      u.value = i?.value?.scrollLeft !== 0;
    }, S = () => {
      _(), ee();
    };
    ve(async () => {
      await me(), S(), M();
    }), fe(() => {
      n && (n.disconnect(), n = null);
    }), q(K, (t) => {
      if (!t || t === "none") return;
      V("slide-impression", { direction: t === "left" ? "forward" : "backward" });
    }), q(
      b,
      () => {
        M();
      },
      { flush: "post" }
    );
    const g = r(() => I?.button?.({})?.[0] ? I.button({})[0] : null), te = r(() => !b.value?.length), le = r(() => l.desktopCardWidth === "narrow" ? [
      j[l.desktopCardWidth],
      Y[l.mobileCardWidth]
    ] : [
      j[l.desktopCardWidth],
      Y[l.mobileCardWidth],
      Te[l.size]
    ]), v = r(() => l.headingSize === "medium"), y = r(() => l.headingSize === "large"), ae = r(() => f.value && v.value), re = r(() => g.value && !f.value && v.value), se = r(() => f.value && (!l.title || y.value)), ie = r(() => g.value || y.value || f.value && !l.title), oe = r(() => ["hidden md:flex", l.title && "md:ml-auto"]), ne = r(() => ({
      "md:ml-auto": l.title && v.value,
      "md:hidden": l.title && !f.value && v.value
    }));
    return Ce(i, () => {
      S();
    }), ge(
      i,
      () => {
        requestAnimationFrame(() => {
          S();
        });
      },
      { attributes: !0, childList: !0, subtree: !0 }
    ), ye([
      {
        reason: "Replaced by `size`, with new values `extra-small`, `small`, `medium`, `large` and `extra-large`",
        deadline: "2025-05-01",
        replacementName: "size",
        props: {
          propName: "desktopCardWidth",
          propValue: l.desktopCardWidth,
          propDefaultValue: "standard"
        }
      },
      {
        reason: "Replaced by `size`, with new values `extra-small`, `small`, `medium`, `large` and `extra-large`",
        deadline: "2025-05-01",
        replacementName: "size",
        props: {
          propName: "mobileCardWidth",
          propValue: l.mobileCardWidth,
          propDefaultValue: "standard"
        }
      }
    ]), (t, e) => te.value ? c("", !0) : (o(), N("section", Ne, [
      s.title ? (o(), N("div", {
        key: 0,
        class: h(["inline-flex flex-row items-end gap-16 md:gap-28", {
          "mb-16": v.value,
          "mb-16 md:mb-24": y.value
        }])
      }, [
        E("div", Ie, [
          (o(), k(B(s.titleTag), {
            id: z,
            class: h(["text-static-default-hi", {
              "punchline text-center": y.value,
              "heading-2": v.value
            }])
          }, {
            default: pe(() => [
              he(H(s.title), 1)
            ]),
            _: 1
          }, 8, ["class"])),
          s.subtitle ? (o(), N("span", {
            key: 0,
            id: $,
            class: h(["text-static-default-low", {
              "heading-3 text-center": y.value,
              "body-1": v.value
            }])
          }, H(s.subtitle), 3)) : c("", !0)
        ]),
        ae.value ? (o(), k(G, {
          key: 0,
          "can-scroll-next": d.value,
          "can-scroll-prev": u.value,
          "first-visible": x.value,
          "last-visible": C.value,
          "next-alternative-text": s.nextAlternativeText,
          "prev-alternative-text": s.prevAlternativeText,
          "total-items": b.value.length,
          onScroll: Z
        }, null, 8, ["can-scroll-next", "can-scroll-prev", "first-visible", "last-visible", "next-alternative-text", "prev-alternative-text", "total-items"])) : c("", !0),
        re.value ? (o(), k(B(U(g.value)), {
          key: 1,
          class: h(oe.value),
          "full-width": "adaptive"
        }, null, 8, ["class"])) : c("", !0)
      ], 2)) : c("", !0),
      E("div", {
        ref: "carousel-scroller",
        class: h(["focus-visible-outline-inset-hi rounded-sm -m-12 snap-x snap-mandatory scroll-pl-12 overflow-x-auto overscroll-x-contain scroll-smooth transition-transform duration-700 scrollbar-none", Q.value]),
        onScroll: S
      }, [
        be(Ae, {
          ref: "carousel-items",
          "aria-labelledby": s.ariaLabelledby || (s.subtitle ? `${z} ${$}` : z),
          "card-classes": le.value,
          center: s.center ? !f.value : !1,
          class: "p-12",
          items: b.value
        }, null, 8, ["aria-labelledby", "card-classes", "center", "items"]),
        E("div", {
          "aria-label": D.value,
          "aria-live": "polite",
          class: "sr-only"
        }, null, 8, ze)
      ], 34),
      ie.value ? (o(), N("div", Ee, [
        g.value ? (o(), k(B(U(g.value)), {
          key: 0,
          class: h(ne.value),
          "full-width": "adaptive"
        }, null, 8, ["class"])) : c("", !0),
        se.value ? (o(), k(G, {
          key: 1,
          "can-scroll-next": d.value,
          "can-scroll-prev": u.value,
          class: "ml-auto",
          "first-visible": x.value,
          "last-visible": C.value,
          "next-alternative-text": s.nextAlternativeText,
          "prev-alternative-text": s.prevAlternativeText,
          "total-items": b.value.length,
          onScroll: F
        }, null, 8, ["can-scroll-next", "can-scroll-prev", "first-visible", "last-visible", "next-alternative-text", "prev-alternative-text", "total-items"])) : c("", !0)
      ])) : c("", !0)
    ]));
  }
});
export {
  qe as default
};
